"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformChildrenToString = transformChildrenToString;
function transformChildrenToString(children, departureAt, shortened) {
    let displayValueString = "";
    const departure = new Date(departureAt);
    const calculateAge = (birthAt) => Math.floor((departure.getTime() - birthAt.getTime()) / 1000 / 60 / 60 / 24 / 365);
    if (children.length > 0) {
        displayValueString += `${children.length} ${children.length > 1 ? "children" : "child"} (`;
        let age = 0;
        children.forEach((p, index) => {
            age = calculateAge(p.birthdayAt ? new Date(p.birthdayAt) : new Date());
            shortened ? (displayValueString += age === 13 ? "12+y" : `${age}y`) : (displayValueString += age === 13 ? "12+" : age);
            if (children.length - 1 !== index) {
                if (children.length - 2 === index && shortened !== true) {
                    displayValueString += " and ";
                }
                else {
                    displayValueString += ", ";
                }
            }
        });
        shortened ? (displayValueString += ")") : (displayValueString += `\u00A0${age === 1 ? "year" : "years"}\u00A0old)`);
    }
    return displayValueString;
}
//# sourceMappingURL=transformChildrenToString.js.map